import { useMemo } from "react";

export type SortFuncMap<T> = Dict<(a: T, b: T) => number>;

export enum SortDirection {
  Asc = "asc",
  Desc = "desc",
}

export function useSorting<T extends object>(
  unsorted: T[],
  sortFuncs: SortFuncMap<T>,
  sortCode: keyof typeof sortFuncs,
  sortDirection: SortDirection
) {
  return useMemo(() => {
    const selectedSortFunc = sortFuncs[sortCode];
    if (!selectedSortFunc) {
      return unsorted;
    }
    const fn: (a: T, b: T) => number =
      sortDirection === SortDirection.Desc ? (a, b) => selectedSortFunc(b, a) : (a, b) => selectedSortFunc(a, b);
    return unsorted.slice().sort(fn);
  }, [unsorted, sortFuncs, sortCode, sortDirection]);
}
